import { ConversationService } from '@klant/conversational-connector/services/conversation/conversation.service';
import { ConversationalChatVisibility } from '@klant/conversational-connector/klant-conversational-connector.model';

import { Component, ElementRef, inject } from '@angular/core';

/**
 * @module WrapperModule
 * @ngdoc component
 * @name WrapperComponent
 */
@Component({
    selector: 'wrapper',
    templateUrl: './wrapper.component.html',
    standalone: false
})
export class WrapperComponent {
    private readonly conversationService = inject(ConversationService);
    private readonly elementRef = inject(ElementRef);

    public openChat(): void {
        this.conversationService.setConversationVisibility(ConversationalChatVisibility.OPEN);
    }

    public sendTestMessage(message: string) {
        if (this.conversationService.getChatVisibility() !== ConversationalChatVisibility.OPEN) {
            this.openChat();
        }

        const testMessageToChat = new CustomEvent('chatMessage', {
            bubbles: true,
            detail: { chatMessage: message }
        });

        this.elementRef.nativeElement.dispatchEvent(testMessageToChat);
    }
}
